/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import {
  TablePaginationConfig,
  TableRowSelection
} from 'antd/es/table/interface';
import { Table as HefestoTable, Pagination } from '@gerdau/hefesto-mais-web';
import { ColumnsType, FilterValue } from 'antd/lib/table/interface';

interface ITableProps<T> {
  columns: ColumnsType<T>;
  data: T[];
  hasPagination?: boolean;
  expandedRowRender?: (record: T) => React.ReactNode;
  rowSelection?: TableRowSelection<T>;
  pageSizeOptions?: number[];
  scroll?: {
    x?: number | true | string | 'max-content';
    y?: number | string | 'max-content';
  };
  expandedColumnPosition?: 'right' | 'left';
  pageSizeInitial?: number;
}

const Table = <GenericDataSource extends { key: React.Key }>({
  columns,
  data = [],
  hasPagination = false,
  rowSelection,
  expandedRowRender,
  pageSizeOptions,
  scroll,
  expandedColumnPosition = 'right',
  pageSizeInitial = 10
}: ITableProps<GenericDataSource>) => {
  const [dataSource, setDataSource] = useState<GenericDataSource[]>([]);
  const [currentSorter, setCurrentSorter] = useState({
    order: 'ascend',
    column: { sorter: (): any => null }
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(pageSizeInitial);

  const sorterHelper = (sorter: any) => {
    let itemHelper = [];
    if (sorter.order === 'ascend') {
      itemHelper = data.concat().sort(sorter.column.sorter);
    } else if (sorter.order === 'descend') {
      itemHelper = data.concat().sort(sorter.column.sorter).reverse();
    } else {
      itemHelper = data;
    }

    return itemHelper;
  };

  // Recalcula a fonte de dados sempre que data, ordenação, página ou tamanho de página mudarem
  useEffect(() => {
    const itemHelper = sorterHelper(currentSorter);
    const start = (currentPage - 1) * pageSize;
    const end = currentPage * pageSize;
    const slicedItems = itemHelper.slice(start, end);

    if (slicedItems.length === 0 && itemHelper.length > 0) {
      // Se a página atual ficou fora do range após uma mudança de dados, volta para a primeira
      setCurrentPage(1);
      setDataSource(itemHelper.slice(0, pageSize));
      return;
    }

    setDataSource(slicedItems);
  }, [data, currentSorter, currentPage, pageSize]);

  function handleTableSort(
    _pagination: TablePaginationConfig,
    _filters: Record<string, FilterValue | null>,
    sorter: any
  ) {
    setCurrentSorter(sorter);
  }

  function handleChange(current: number, pageSizeTable: number) {
    setCurrentPage(current);
    setPageSize(pageSizeTable);
  }

  return (
    <>
      <HefestoTable
        expandedColumnPosition={expandedColumnPosition}
        columns={columns}
        dataSource={dataSource}
        onChange={handleTableSort}
        expandedRowRender={expandedRowRender}
        rowSelection={rowSelection}
        scroll={scroll}
      />
      {hasPagination && (
        <Pagination
          showTotal
          total={data.length}
          onChange={handleChange}
          pageSizeOptions={pageSizeOptions}
        />
      )}
    </>
  );
};

export default Table;
